

export const t = function <T>(params: Record<string, T>): T {
    return params[document.documentElement.lang];
}